<script>
    
    import ListItem from "../lib/components/products/ListItem.svelte";
    import {onMount} from 'svelte'
	import Filters from '../lib/stores/filters';
	let all_products = [];
	let products = [];
	export let cat;
	export let title;
	onMount(() => {
		let url = cat ? `https://crm.lamara.in/products/products/productslist?cat=${cat}` : 'https://crm.lamara.in/products/products/productslist'
		fetch(url).then(res => res.json()).then(res => {
			products = res.data;
			all_products = [...products];
		})
	})
	Filters.subscribe(f => {
		products = [];
		if(f.filters_list.length || f.product_sizes.length){
			fetch("https://crm.lamara.in/products/products/productsbyfilters",{
				method: "POST",
				body: JSON.stringify({
					data: f
				})
			}).then(res => res.json()).then(res => {
				if(!res.error)
				products = res.data;
				else
				products = [];
			})
		}else{
			products = all_products;
		}
	})
</script>
<div class="row show-case-items justify-content-center">
    <div class="col-12 col-md-10">
        <div class="row">
            {#each products as  product}
                <ListItem product={product}/>
            {:else}
                <!-- Oops! No cakes found! -->
                Baking in process....
            {/each}
        </div>
    </div>
</div>

<style lang="scss">
    .show-case-items {
        margin-top: 100px;
        margin-bottom: 40px;
    }
</style>